/**
 * map-layer-filter.js
 * Fitur: Legend interaktif dengan checkbox untuk filter marker per tab
 * - Tab AWLR  : filter by warning_status (Normal/Waspada/Siaga/Awas)
 * - Tab ARR   : filter by intensity_last_hour
 * - Tab WQ    : filter by quality_status
 * - Semua tab : checkbox DAS & Sungai (default unchecked)
 *
 * ES5 Compatible - tidak menggunakan const, let, arrow function, template literal
 */

// ============================================================
// 1. STATE — diingat per tab, default semua checked
// ============================================================
var markerFilterState = {
  'tab-awlr': { 0: true, 1: true, 2: true, 3: true },
  'tab-arr': {
    Cerah: true,
    Berawan: true,
    'Tidak Hujan': true,
    'Hujan Ringan': true,
    'Hujan Sedang': true,
    'Hujan Lebat': true,
    'Hujan Sangat Lebat': true,
  },
  'tab-wq': {
    Baik: true,
    'Cemar Ringan': true,
    'Cemar Sedang': true,
    'Cemar Berat': true,
  },
};

// State DAS & Sungai — default unchecked
var overlayState = {
  das: false,
  sungai: false,
};

function appendImageVersion(url) {
  if (!url) return url;
  return (
    url + (url.indexOf('?') === -1 ? '?' : '&') + 'v=' + IMAGE_ASSET_VERSION
  );
}

// ============================================================
// 2. KONFIGURASI LEGEND PER TAB
// ============================================================
var legendConfig = {
  'tab-awlr': {
    title: 'Status Siaga :',
    items: [
      {
        label: 'Normal (Siaga IV)',
        status: '0',
        icon: '/images/awlr/siaga_4.png',
      },
      {
        label: 'Waspada (Siaga III)',
        status: '3',
        icon: '/images/awlr/siaga_3.png',
      },
      {
        label: 'Siaga (Siaga II)',
        status: '2',
        icon: '/images/awlr/siaga_2.png',
      },
      {
        label: 'Awas (Siaga I)',
        status: '1',
        icon: '/images/awlr/siaga_1.png',
      },
    ],
    stateKey: 'tab-awlr',
  },
  'tab-arr': {
    title: 'Kondisi Cuaca :',
    items: [
      {
        label: 'Cerah',
        status: 'Cerah',
        icon: '/images/arr/berawan-siang-outline.png',
      },
      {
        label: 'Hujan Ringan (1-5 mm/jam)',
        status: 'Hujan Ringan',
        icon: '/images/arr/hujan-ringan.png',
      },
      {
        label: 'Hujan Sedang (5-10 mm/jam)',
        status: 'Hujan Sedang',
        icon: '/images/arr/hujan-sedang.png',
      },
      {
        label: 'Hujan Lebat (10-20 mm/jam)',
        status: 'Hujan Lebat',
        icon: '/images/arr/hujan-lebat.png',
        status: 'Hujan Lebat',
        icon: '/images/arr/hujan-lebat.png',
      },
      {
        label: 'Hujan Sangat Lebat (20-100 mm/jam)',
        status: 'Hujan Sangat Lebat',
        icon: '/images/arr/hujan-sangat-lebat.png',
      },
      {
        label: 'Hujan Ekstrem ( > 100 mm/jam)',
        status: 'Hujan Ekstrem',
        icon: '/images/arr/hujan-ekstreme.png',
      },
    ],
    stateKey: 'tab-arr',
  },
  'tab-wq': {
    title: 'Index Kualitas Air :',
    items: [
      {
        label: 'Baik',
        status: 'Baik',
        icon: '/images/water-quality/wq-normal.svg',
      },
      {
        label: 'Cemar Ringan',
        status: 'Cemar Ringan',
        icon: '/images/water-quality/wq-cemar-ringan.svg',
      },
      {
        label: 'Cemar Sedang',
        status: 'Cemar Sedang',
        icon: '/images/water-quality/wq-cemar-sedang.svg',
      },
      {
        label: 'Cemar Berat',
        status: 'Cemar Berat',
        icon: '/images/water-quality/wq-cemar-berat.svg',
      },
    ],
    stateKey: 'tab-wq',
  },
};

// ============================================================
// 3. RENDER LEGEND DINAMIS
// ============================================================

function renderLegendForTab(tabId) {
  var legendEl = document.getElementById('legend-unified');
  if (!legendEl) return;

  var config = legendConfig[tabId];

  if (!config) {
    legendEl.style.display = 'none';
    return;
  }

  legendEl.style.display = 'block';

  var state = markerFilterState[config.stateKey];
  var i, item, isChecked;
  var itemsHtml = '';

  for (i = 0; i < config.items.length; i++) {
    item = config.items[i];
    isChecked = state[item.status] !== false;

    itemsHtml +=
      '<label class="legend-filter-item" style="display:flex; align-items:center; margin-bottom:6px; cursor:pointer; user-select:none;">';
    itemsHtml += '<input type="checkbox"';
    itemsHtml += ' class="legend-marker-checkbox"';
    itemsHtml += ' data-tab="' + tabId + '"';
    itemsHtml += ' data-status="' + item.status + '"';
    itemsHtml += isChecked ? ' checked' : '';
    itemsHtml +=
      ' style="margin-right:6px; cursor:pointer; width:14px; height:14px;">';

    if (tabId == 'tab-wq') {
      itemsHtml +=
        '<img src="' +
        appendImageVersion(item.icon) +
        '" style="width:30px; height:30px; margin-right:6px; object-fit:contain;">';
      itemsHtml += '<span style="font-size:12px;">' + item.label + '</span>';
    } else {
      itemsHtml +=
        '<img src="' +
        appendImageVersion(item.icon) +
        '" style="width:25px; height:25px; margin-right:6px; object-fit:contain;">';
      itemsHtml += '<span style="font-size:12px;">' + item.label + '</span>';
    }

    itemsHtml += '</label>';
  }

  var dasChecked = overlayState.das ? ' checked' : '';
  var sungaiChecked = overlayState.sungai ? ' checked' : '';

  var overlayHtml = '';
  overlayHtml += '<hr style="border-color:rgba(0,0,0,0.2); margin:8px 0;">';
  overlayHtml +=
    '<label class="legend-filter-item" style="display:flex; align-items:center; margin-bottom:6px; cursor:pointer; user-select:none;">';
  overlayHtml +=
    '<input type="checkbox" id="chk-overlay-das" class="legend-overlay-checkbox" data-overlay="das"' +
    dasChecked +
    ' style="margin-right:6px; cursor:pointer; width:14px; height:14px;">';
  overlayHtml += '<span style="font-size:12px;">DAS</span>';
  overlayHtml += '</label>';
  overlayHtml +=
    '<label class="legend-filter-item" style="display:flex; align-items:center; margin-bottom:4px; cursor:pointer; user-select:none;">';
  overlayHtml +=
    '<input type="checkbox" id="chk-overlay-sungai" class="legend-overlay-checkbox" data-overlay="sungai"' +
    sungaiChecked +
    ' style="margin-right:6px; cursor:pointer; width:14px; height:14px;">';
  overlayHtml += '<span style="font-size:12px;">Sungai</span>';
  overlayHtml += '</label>';

  legendEl.innerHTML =
    '<h4 style="margin:0 0 8px; font-size:13px;">' +
    config.title +
    '</h4>' +
    itemsHtml +
    overlayHtml;
}

// ============================================================
// 4. FILTER MARKER
// ============================================================

function applyAwlrMarkerFilter() {
  var state = markerFilterState['tab-awlr'];
  awlr_marker.eachLayer(function (layer) {
    var ws =
      layer.options.warningStatus != null
        ? String(layer.options.warningStatus)
        : '';
    if (!state.hasOwnProperty(ws)) ws = '0'; // ← tambah
    var visible = state[ws]; // ← ganti
    _setMarkerVisibility(layer, visible);
  });
}

function applyArrMarkerFilter() {
  var state = markerFilterState['tab-arr'];
  arr_marker.eachLayer(function (layer) {
    var intensity = layer.options.intensityStatus || 'Cerah';
    if (intensity === 'Berawan' || intensity === 'Tidak Hujan') {
      intensity = 'Cerah';
    }
    var visible = state.hasOwnProperty(intensity) ? state[intensity] : true;
    _setMarkerVisibility(layer, visible);
  });
}

function applyWqMarkerFilter() {
  var state = markerFilterState['tab-wq'];
  wq_marker.eachLayer(function (layer) {
    var quality = layer.options.qualityStatus || '';
    var key = _toTitleCase(quality);
    if (!state.hasOwnProperty(key)) key = 'Baik'; // ← tambah
    var visible = state[key]; // ← ganti
    _setMarkerVisibility(layer, visible);
  });
}

function _setMarkerVisibility(layer, visible) {
  if (typeof layer.setOpacity === 'function') {
    layer.setOpacity(visible ? 1 : 0);
  }
  if (layer._icon) {
    layer._icon.style.pointerEvents = visible ? 'auto' : 'none';
    layer._icon.style.opacity = visible ? '1' : '0';
  }
  if (layer._shadow) {
    layer._shadow.style.opacity = visible ? '1' : '0';
  }
}

function _toTitleCase(str) {
  if (!str) return '';
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

// ============================================================
// 5. SYNC LAYER PER TAB AKTIF
// ============================================================

function syncLayerWithActiveTab(tabId) {
  if (map.hasLayer(awlr_marker)) map.removeLayer(awlr_marker);
  if (map.hasLayer(arr_marker)) map.removeLayer(arr_marker);
  if (map.hasLayer(wq_marker)) map.removeLayer(wq_marker);

  if (tabId === 'tab-awlr') {
    awlr_marker.addTo(map);
    applyAwlrMarkerFilter();
  } else if (tabId === 'tab-arr') {
    arr_marker.addTo(map);
    applyArrMarkerFilter();
  } else if (tabId === 'tab-wq') {
    wq_marker.addTo(map);
    applyWqMarkerFilter();
  }
  // tab-cctv: tidak ada marker

  renderLegendForTab(tabId);
}

// ============================================================
// 6. EVENT HANDLERS CHECKBOX
// ============================================================

function initLegendCheckboxEvents() {
  $(document).on('change', '.legend-marker-checkbox', function () {
    var tabId = $(this).data('tab');
    var status = String($(this).data('status'));
    var checked = this.checked;

    if (markerFilterState[tabId]) {
      markerFilterState[tabId][status] = checked;
      // Alias status lama untuk filter Cerah
      if (tabId === 'tab-arr' && status === 'Cerah') {
        markerFilterState[tabId]['Berawan'] = checked;
        markerFilterState[tabId]['Tidak Hujan'] = checked;
      }
    }

    if (tabId === 'tab-awlr') applyAwlrMarkerFilter();
    if (tabId === 'tab-arr') applyArrMarkerFilter();
    if (tabId === 'tab-wq') applyWqMarkerFilter();
  });

  $(document).on('change', '.legend-overlay-checkbox', function () {
    var overlay = $(this).data('overlay');
    var checked = this.checked;

    overlayState[overlay] = checked;

    if (overlay === 'das') {
      _toggleOverlayLayer(window.geojsonLayerDAS, checked);
    } else if (overlay === 'sungai') {
      _toggleOverlayLayer(window.geojsonLayerSungai, checked);
    }
  });
}

function _toggleOverlayLayer(layer, show) {
  if (!layer) return;
  if (show) {
    if (!map.hasLayer(layer)) layer.addTo(map);
  } else {
    if (map.hasLayer(layer)) map.removeLayer(layer);
  }
}

// ============================================================
// 7. LEGEND CONTROL UNIFIED
// ============================================================

function createUnifiedLegend() {
  var unifiedLegend = L.control({ position: 'bottomleft' });

  unifiedLegend.onAdd = function () {
    var div = L.DomUtil.create('div', 'info legend small-legend');
    div.id = 'legend-unified';
    div.style.background = 'rgba(255,255,255,0.85)';
    div.style.padding = '10px 12px';
    div.style.borderRadius = '5px';
    div.style.boxShadow = '0 0 15px rgba(0,0,0,0.2)';
    div.style.minWidth = '200px';
    div.style.display = 'none';

    L.DomEvent.disableClickPropagation(div);
    L.DomEvent.disableScrollPropagation(div);

    return div;
  };

  unifiedLegend.addTo(map);
}

// ============================================================
// 8. INIT
// ============================================================

function initMapLayerFilter() {
  createUnifiedLegend();
  initLegendCheckboxEvents();

  var lastTab = localStorage.getItem('tab-center-left') || 'tab-awlr';
  syncLayerWithActiveTab(lastTab);

  $('#tab-center-left a[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
    var tabId = $(this).attr('href').replace('#', '');
    syncLayerWithActiveTab(tabId);
  });
}
